import { getPlatform } from './platform';

let provider = null;

const PaymentService = {
  async initialize() {
    // Apple IAP is the only payment path. On web the provider degrades
    // gracefully (purchases unavailable; entitlement reads still work).
    const { ApplePaymentProvider } = await import('./payment-apple');
    provider = ApplePaymentProvider;
    return provider.initialize();
  },

  async getProducts() {
    if (!provider) await this.initialize();
    return provider.getProducts();
  },

  async purchase(productId) {
    if (!provider) await this.initialize();
    return provider.purchase(productId);
  },

  async manageSubscription() {
    if (!provider) await this.initialize();
    return provider.manageSubscription();
  },

  async restorePurchases() {
    if (!provider) await this.initialize();
    return provider.restorePurchases();
  },

  async getEntitlements() {
    if (!provider) await this.initialize();
    return provider.getEntitlements();
  },

  getPlatform() {
    return getPlatform();
  },
};

export default PaymentService;
